import React from 'react';
import { Button, Card, Col, Input, Row, Typography } from 'antd';
import { FileTextOutlined, PlusOutlined, ShoppingCartOutlined, TeamOutlined } from '@ant-design/icons';
import { useI18n } from '../i18n';
import { brandSemantic } from '../config/brand';

const { Search } = Input;
const { Title, Text } = Typography;

export default function StartPage({ setCurrentView, showModal }) {
  const { t } = useI18n();
  return (
    <div>
      <div className="page-toolbar" style={{ marginBottom: '24px' }}>
        <div className="page-toolbar-controls" style={{ justifyContent: 'flex-start', maxWidth: '700px' }}>
          <Search
            placeholder={t('Search by name, phone, email, or CVR') + '...'}
            style={{ flex: 1 }}
            size="large"
          />
          <Button size="large">{t('Clear')}</Button>
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          size="large"
          onClick={() => {
            setCurrentView('leads');
            showModal('createLead');
          }}
        >
          {t('Add New Lead/Client')}
        </Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Card
            hoverable
            onClick={() => setCurrentView('leads')}
            style={{ textAlign: 'center', height: '160px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
          >
            <TeamOutlined style={{ fontSize: '40px', color: brandSemantic.info, marginBottom: '12px' }} />
            <Title level={4} style={{ margin: '0 0 8px 0', fontSize: '18px' }}>{t('Clients & Suppliers')}</Title>
            <Text type="secondary" style={{ fontSize: '13px' }}>{t('Manage prospects and customers')}</Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card
            hoverable
            onClick={() => setCurrentView('contacts')}
            style={{ textAlign: 'center', height: '160px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
          >
            <FileTextOutlined style={{ fontSize: '40px', color: brandSemantic.success, marginBottom: '12px' }} />
            <Title level={4} style={{ margin: '0 0 8px 0', fontSize: '18px' }}>{t('Contact Records')}</Title>
            <Text type="secondary" style={{ fontSize: '13px' }}>{t('Track communication history')}</Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card
            hoverable
            onClick={() => setCurrentView('offers')}
            style={{ textAlign: 'center', height: '160px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
          >
            <ShoppingCartOutlined style={{ fontSize: '40px', color: brandSemantic.warning, marginBottom: '12px' }} />
            <Title level={4} style={{ margin: '0 0 8px 0', fontSize: '18px' }}>{t('Sales Quotes / Orders')}</Title>
            <Text type="secondary" style={{ fontSize: '13px' }}>{t('View and manage all deals')}</Text>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
